import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema7 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema7_Analisis_Datos.pdf`;
  /*const pdfUrl = "/pdf/Tema7_Analisis_Datos.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 7: Análisis de Datos</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 7: Análisis de Datos" />
      </Container>
    </>
  );
};

 export default PythonTema7;
